import { useTranslateProductName } from 'hooks/use-translate-payoff';

interface ProductSubtypeNameProps {
  pinned: boolean;
  productType: string;
  productSubType: string;
}

export const ProductSubtypeName = ({ pinned, productType, productSubType }: ProductSubtypeNameProps) => {
  const { productTypeLabel, productSubtypeLabel } = useTranslateProductName(productType, productSubType);
  return (
    <span className="text-primary text-wrap text-start me-auto">
      {pinned ? (
        <>
          <span className="text-secondary">{productTypeLabel}</span>
          <span className="text-secondary"> / </span>
        </>
      ) : (
        ''
      )}
      {productSubtypeLabel}
    </span>
  );
};
